import { MapPin, Mail } from "lucide-react";
import { BRAND } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="bg-[#071f33]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img src="/bsa-logo.png" alt="BSA Skills Academy logo" className="h-10 w-10 rounded-lg bg-white object-contain p-0.5" />
              <span className="font-heading leading-tight">
                <span className="block text-sm font-extrabold text-white">{BRAND.fullName}</span>
                <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-400">Tutoring</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              {BRAND.tagline} Practical learning. Real possibilities. Tutoring in Mathematics, Mathematical Literacy,
              Science and CAD for Grades 6–12 — online across South Africa and in person in Witbank.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading text-sm font-bold uppercase tracking-wider text-white/80">Explore</p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/60">
              {[
                ["#subjects", "Subjects"],
                ["#how-it-works", "How it works"],
                ["#about", "About the academy"],
                ["#pricing", "Pricing & packages"],
                ["#book", "Book a lesson"],
                ["#faqs", "FAQs"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="transition-colors duration-200 hover:text-amber-400" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading text-sm font-bold uppercase tracking-wider text-white/80">Visit us</p>
            <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-white/60" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
              {BRAND.address}
            </p>
            <a href={`mailto:${BRAND.email}`} className="mt-3 flex items-center gap-2 text-sm text-white/60 transition-colors duration-200 hover:text-amber-400" data-testid="footer-email">
              <Mail className="h-4 w-4 text-amber-400" /> {BRAND.email}
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8" data-testid="footer-privacy">
          <p className="font-heading text-sm font-bold text-white/80">Privacy notice</p>
          <p className="mt-3 max-w-4xl text-xs leading-relaxed text-white/50">
            {BRAND.fullName} (Pty) Ltd collects the information submitted through the forms on this page so that we can
            respond to questions about tutoring, bookings and related opportunities. Information submitted may include
            your name, contact details, subject of interest and your message, and is used primarily to respond to your
            enquiry. Please do not submit passwords, banking details, identity-document numbers or other unnecessary
            sensitive information through these forms. For questions about information submitted through this website,
            contact {BRAND.email}.
          </p>
          <p className="mt-6 text-xs text-white/40">
            © {new Date().getFullYear()} {BRAND.fullName}. Established {BRAND.founded}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
